<template>
  <section class="section-usps">
    <div class="container">
        <div class="usps-root">
          <!-- put an carousel if mobile -->
          <template v-if="mobile">
            <div class="slider">
                <carousel :auto="2000" :speed="500" :prev-html="sliderOpt.control" :next-html="sliderOpt.control" :watch-items="usps">
                    <carousel-item v-for="(item, index) in usps" :key="index" class="slider--usps-root--items">
                      <div class="flex">
                        <img :src="`${pathImg}${item.icon}`" :alt="item.title">
                        <h3>{{ item.title }}</h3>
                        <span class="desc">{{ item.body }}</span>
                      </div>
                    </carousel-item>
                </carousel>
            </div> 
          </template>

          <!-- Otherwise, generate regular usps -->
          <template v-if="mobile === false">
            <div v-for="(item, index) in usps" :key="index" class="usps-root--items" :data-id="index">
                <img :src="`${pathImg}${item.icon}`" :alt="item.title">
                <h3>{{ item.title }}</h3>
                <span class="desc">{{ item.body }}</span>
            </div>
          </template>
        </div>
    </div>
  </section>
</template>
<script>
import { Carousel, CarouselItem } from 'vue-l-carousel'
export default {
  name: 'Usps',
  components: { Carousel, CarouselItem },
  props: ['usps', 'mobile'],
  data () {
    return {
      'pathImg': '/static/usp-icons/', // these icons are not resolved by webpack so placed in static folder
      sliderOpt: {
        'control': '<span></span>'
      }
    }
  },
  mounted () {
  }
}
</script>
<style lang="css" scoped>
  @import 'vue-l-carousel/dist/main.css';
</style>




// WEBPACK FOOTER //
// src/components/Usps.vue